import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const PositioningTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();
    const data = rows.filter(row => row.Category === "POSITIONING");
    return <EconomicTable
        data={data}
        title="Positioning Analysis"
        defaultRowData={{ Category: "POSITIONING", Topic: "Futures Positioning" }}
        groupBy="Topic"
        groupOrder={[
            "Futures Positioning",
            "Gamma Exposure",
            "CTA Trends",
            "Risk Appetite",
            "Short Interest"
        ]}
        useDataHook={useMarketInternalsData}
    />;
};

export default PositioningTab;
